import { Footer, Header, Page, PageTransition } from '@components/Page'
import { pickSeoProps } from '@components/Page/Page'
import { ProductOverview } from '@components/_product-overview/Overview'
import { RCPOBanner } from '@components/_rcpo/RCPOBanner'
import { SingleItemResponse } from '@lib/kontent'
import { BrandPage as BrandPageModel } from '@lib/kontent/models/BrandPage'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { FC } from 'react'

type BrandPageProps = SingleItemResponse<BrandPageModel>

const BrandPage: FC<BrandPageProps> = (props) => {
  const isPreOwned = props.item.elements?.category?.value[0]?.codename === 'pre_owned'
  let rcpoTitle: string | null = null
  let rcpoImage: AssetsElement | null = null

  const { rcpo_banner_text, rcpo_banner } = props.item.elements

  if (isPreOwned && rcpo_banner_text?.value && rcpo_banner?.value[0]) {
    rcpoTitle = rcpo_banner_text.value
    rcpoImage = rcpo_banner
  }

  return (
    <Page {...pickSeoProps(props.item.elements)}>
      <Header initialVariant="absolute" />
      <PageTransition>
        <ProductOverview
          preProductBanner={
            isPreOwned &&
            rcpoTitle &&
            rcpoImage && <RCPOBanner title={rcpoTitle} image={rcpoImage} />
          }
          {...props}
        />
        <Footer />
      </PageTransition>
    </Page>
  )
}

export default BrandPage
